<template>
  <!-- 核心技术 -->
  <div class="core">
    <lists :categoryId="id"></lists>
  </div>
</template>

<script>
import lists from "../components/Lists";
export default {
  name: "core",
  components: { lists },
  data() {
    return {
      id: this.$map.corecategoryId,
    };
  },
};
</script>

<style scoped lang="less">
.core {
}
</style>
